import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/ja'
import "./css/theme.scss";
import vueJsonp from 'vue-jsonp'
Vue.use(vueJsonp)
import VueWechatTitle from 'vue-wechat-title'
import Meta from 'vue-meta'
Vue.use(Meta)
Vue.use(VueWechatTitle)
import axios from 'axios'
import install from './api/axios'
import './utlis/common'

Vue.use(install)
Vue.use(ElementUI, { locale })
Vue.prototype.$http = axios
Vue.config.productionTip = false
// Vue.directive('focus', {
//     inserted(el) {
//         el.focus()
//     }
// })
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

